<template>
    <basic-container>
      <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>提现管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <avue-crud
        :option="option"
        :data="data"
        :page.sync="page"
        ref="crud"
        v-model="form"
        :permission="permissionList"
        @refresh-change="refreshChange"
        @on-load="onLoad"
        :header-cell-class-name="headerCellClassName"
      >
        <template slot-scope="scope" slot="menu">
          <el-button v-if="scope.row.status === 7" type="text" size="small" @click="openComplete(scope.row)">转账完成</el-button>
          <el-button v-if="scope.row.status === 7" type="text" size="small" style="color: #f56c6c" @click="openFail(scope.row)">转账失败</el-button>
          <el-button v-if="scope.row.status === 7 && scope.row.isNegotiate !== 1" type="text" size="small" @click="openNegotiate(scope.row)">协商转账</el-button>
          <el-button v-if="scope.row.status === 6" type="text" size="small" @click="openUnfreeze(scope.row)">手动解冻</el-button>
        </template>
      </avue-crud>
      <!-- 人工转账完成 -->
      <el-dialog title="人工转账完成" :visible.sync="completeVisible" width="500px">
        <el-form :model="completeForm" label-width="120px">
          <el-form-item label="提现单号"><el-input v-model="completeForm.applyNo" disabled /></el-form-item>
          <el-form-item label="转账流水号" required>
            <el-input v-model="completeForm.manualTransferNo" placeholder="请输入银行流水号" clearable />
          </el-form-item>
          <el-form-item label="转账凭证URL">
            <el-input v-model="completeForm.voucherUrl" placeholder="选填" clearable />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="completeVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitComplete" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 人工转账失败 -->
      <el-dialog title="人工转账失败" :visible.sync="failVisible" width="500px">
        <el-form :model="failForm" label-width="120px">
          <el-form-item label="提现单号"><el-input v-model="failForm.applyNo" disabled /></el-form-item>
          <el-form-item label="失败原因" required>
            <el-input v-model="failForm.failReason" type="textarea" :rows="3" placeholder="请输入失败原因" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="failVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitFail" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 协商转账 -->
      <el-dialog title="协商转账" :visible.sync="negotiateVisible" width="500px">
        <el-form :model="negotiateForm" label-width="120px">
          <el-form-item label="订单ID"><el-input v-model="negotiateForm.orderId" disabled /></el-form-item>
          <el-form-item label="转账金额" required>
            <el-input-number v-model="negotiateForm.amount" :precision="2" :min="0.01" />
          </el-form-item>
          <el-form-item label="银行卡号" required>
            <el-input v-model="negotiateForm.bankCardNo" placeholder="请输入银行卡号" clearable />
          </el-form-item>
          <el-form-item label="银行卡户名" required>
            <el-input v-model="negotiateForm.bankAccountName" placeholder="请输入户名" clearable />
          </el-form-item>
          <el-form-item label="开户行" required>
            <el-input v-model="negotiateForm.bankName" placeholder="请输入开户行" clearable />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="negotiateVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitNegotiate" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 手动解冻 -->
      <el-dialog title="客服手动解冻" :visible.sync="unfreezeVisible" width="500px">
        <el-form :model="unfreezeForm" label-width="120px">
          <el-form-item label="提现单号"><el-input v-model="unfreezeForm.applyNo" disabled /></el-form-item>
          <el-form-item label="解冻原因" required>
            <el-input v-model="unfreezeForm.reason" type="textarea" :rows="3" placeholder="请输入解冻原因" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="unfreezeVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitUnfreeze" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
    </basic-container>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import {
    getWithdrawalList,
    manualComplete,
    manualFail,
    negotiateTransfer,
    manualUnfreeze
  } from "@/api/healthmanagement/deviceManage";

  const withdrawStatusDic = [
    { label: "待用户确认", value: 1 },
    { label: "已提现", value: 3 },
    { label: "提现失败", value: 4 },
    { label: "已取消", value: 6 },
    { label: "待转账", value: 7 },
    { label: "已转账", value: 8 }
  ];

  const withdrawTypeDic = [
    { label: "微信零钱", value: 1 },
    { label: "银行卡", value: 2 }
  ];

  export default {
    data() {
      return {
        form: {},
        data: [],
        page: { pageSize: 10, currentPage: 1, total: 0 },
        headerCellClassName: "headerClass",
        submitting: false,

        // 转账完成
        completeVisible: false,
        completeForm: { applyNo: "", manualTransferNo: "", voucherUrl: "" },

        // 转账失败
        failVisible: false,
        failForm: { applyNo: "", failReason: "" },

        // 协商转账
        negotiateVisible: false,
        negotiateForm: { orderId: "", amount: 0, bankCardNo: "", bankAccountName: "", bankName: "" },

        // 手动解冻
        unfreezeVisible: false,
        unfreezeForm: { applyNo: "", reason: "" },

        option: {
          tip: false,
          border: true,
          index: true,
          indexLabel: "序号",
          addBtn: false,
          editBtn: false,
          viewBtn: false,
          delBtn: false,
          selection: false,
          menuWidth: 240,
          searchMenuSpan: 5,
          column: [
            { label: "提现单号", prop: "applyNo", search: true, overHidden: true },
            { label: "订单ID", prop: "orderId", search: true, overHidden: true },
            { label: "提现金额", prop: "amount" },
            { label: "提现方式", prop: "withdrawType", type: "select", dicData: withdrawTypeDic },
            {
              label: "是否协商",
              prop: "isNegotiate",
              formatter: row => row.isNegotiate === 1 ? "是" : "否"
            },
            {
                label: "状态",
                prop: "status",
                type: "select",
                dicData: withdrawStatusDic
            },
            { label: "失败原因", prop: "failReason", overHidden: true },
            { label: "创建时间", prop: "createTime", }
          ]
        }
      };
    },

    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return { addBtn: false, viewBtn: false, delBtn: false, editBtn: false };
      }
    },

    methods: {
      onLoad(page, params = {}) {
        getWithdrawalList(page.currentPage, page.pageSize, params).then(res => {
          const data = res.data;
          this.page.total = data.total;
          this.data = data.records || [];
        });
      },

      refreshChange(data) {
        this.onLoad(this.page, data.searchForm);
      },

      /**
       * 打开人工转账完成弹窗
       */
      openComplete(row) {
        this.completeForm = {
          applyNo: row.applyNo,
          manualTransferNo: "",
          voucherUrl: ""
        };
        this.completeVisible = true;
      },

      /**
       * 提交人工转账完成
       */
      submitComplete() {
        if (!this.completeForm.manualTransferNo) {
          this.$message.warning("请输入转账流水号");
          return;
        }

        this.submitting = true;
        manualComplete(this.completeForm)
          .then(res => {
            this.submitting = false;
            if (res.success !== false) {
              this.$message.success("操作成功");
              this.completeVisible = false;
              this.onLoad(this.page);
            } else {
              this.$message.error(res.msg || "操作失败");
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      },

      /**
       * 打开人工转账失败弹窗
       */
      openFail(row) {
        this.failForm = {
          applyNo: row.applyNo,
          failReason: ""
        };
        this.failVisible = true;
      },

      /**
       * 提交人工转账失败
       */
      submitFail() {
        if (!this.failForm.failReason) {
          this.$message.warning("请输入失败原因");
          return;
        }

        this.submitting = true;
        manualFail(this.failForm)
          .then(res => {
            this.submitting = false;
            if (res.success !== false) {
              this.$message.success("操作成功");
              this.failVisible = false;
              this.onLoad(this.page);
            } else {
              this.$message.error(res.msg || "操作失败");
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      },

      /**
       * 打开协商转账弹窗
       */
      openNegotiate(row) {
        this.negotiateForm = {
          orderId: row.orderId,
          amount: row.amount || 0,
          bankCardNo: "",
          bankAccountName: "",
          bankName: ""
        };
        this.negotiateVisible = true;
      },

      /**
       * 提交协商转账
       */
      submitNegotiate() {
        const f = this.negotiateForm;
        if (!f.amount || f.amount <= 0) {
          this.$message.warning("请输入转账金额");
          return;
        }
        if (!f.bankCardNo || !f.bankAccountName || !f.bankName) {
          this.$message.warning("请填写完整的银行卡信息");
          return;
        }

        this.submitting = true;
        negotiateTransfer(f)
          .then(res => {
            this.submitting = false;
            if (res.success !== false) {
              this.$message.success("操作成功");
              this.negotiateVisible = false;
              this.onLoad(this.page);
            } else {
              this.$message.error(res.msg || "操作失败");
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      },

      /**
       * 打开手动解冻弹窗
       */
      openUnfreeze(row) {
        this.unfreezeForm = {
          applyNo: row.applyNo,
          reason: ""
        };
        this.unfreezeVisible = true;
      },

      /**
       * 提交手动解冻
       */
      submitUnfreeze() {
        if (!this.unfreezeForm.reason) {
          this.$message.warning("请输入解冻原因");
          return;
        }

        this.submitting = true;
        manualUnfreeze(this.unfreezeForm)
          .then(res => {
            this.submitting = false;
            if (res.success !== false) {
              this.$message.success("操作成功");
              this.unfreezeVisible = false;
              this.onLoad(this.page);
            } else {
              this.$message.error(res.msg || "操作失败");
            }
          })
          .catch(() => {
            this.submitting = false;
          });
      }
    }
  };
  </script>

  <style scoped>
  .headerClass {
    background-color: #409eff !important;
    color: #fff !important;
  }
  </style>
